<template>
  <div class="signup">
    <b-container>
      <b-row>
        <b-col md="6" lg="5">
          <div class="form-decorated">
            <loader v-if="isLoading" />

            <div class="errors" v-if="!!error">
              <b-alert v-for="(message, index) in error" show :key="`error-${index}`" variant="danger">
                {{ message }}
              </b-alert>
            </div>

            <b-form @submit.prevent="onSubmit" novalidate>
              <b-form-group id="email" label="Your e-mail" label-for="email">
                <b-form-input id="email" type="email" v-model="form.email" :state="getFieldState('email')" />

                <b-form-invalid-feedback>
                  {{ !$v.form.email.required ? 'Email is required' : 'Email must have valid email address' }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="username" label="Choose a username (for fan profile)" label-for="username">
                <b-form-input id="username" type="text" v-model.trim="form.username" placeholder="exampleuser" :state="getFieldState('username')" />

                <b-form-invalid-feedback>
                  {{ !$v.form.username.required ? 'Username is required' : `Username must contain at least ${$v.form.username.$params.minLength.min} characters (lowercase letters and numbers only)` }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="password" label="Choose your password" label-for="password">
                <b-form-input id="password" type="password" v-model="form.password" :state="getFieldState('password')" />

                <b-form-invalid-feedback>
                  {{ !$v.form.password.required ? 'Password is required' : `Password must have at least ${$v.form.password.$params.minLength.min} characters` }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="repeat-password" label="Repeat your password" label-for="repeat-password">
                <b-form-input id="repeat-password" type="password" v-model="form.repeatPassword" :state="getFieldState('repeatPassword')" />

                <b-form-invalid-feedback>
                  Password does not match
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="terms-of-use" :state="getFieldState('terms')" invalid-feedback="You must agree to Terms of Use">
                <b-form-checkbox id="terms" v-model="form.terms" :state="getFieldState('terms')">
                  I accept the <a href="/site/tos" target="_blank">Terms of Use</a>
                </b-form-checkbox>
              </b-form-group>
              <vue-recaptcha
                  ref="recaptcha"
                  @verify="onCaptchaVerified"
                  @expired="onCaptchaExpired"
                  size="invisible"
                  :sitekey="RECAPTCHA_SITE_KEY">
                </vue-recaptcha>
              <b-button type="submit" class="btn-decorated">Sign up</b-button>
            </b-form>
          </div>

          <social-login class="social-login" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { mapGetters, mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email, minLength, sameAs, helpers } from 'vuelidate/lib/validators'
import {RECAPTCHA_SITE_KEY} from '@/constants'

import Loader from '@/components/widgets/Loader'
import SocialLogin from '@/components/widgets/SocialLogin'

const validUsername = helpers.regex('validUsername', /^[a-z0-9]+$/)

const mustBeChecked = value => value

export default {
  name: 'Signup',
  components: {
    Loader,
    SocialLogin,
    VueRecaptcha
  },
  data () {
    return {
      form: {
        email: '',
        username: '',
        password: '',
        repeatPassword: '',
        terms: false
      },
      RECAPTCHA_SITE_KEY
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      email: {
        required,
        email
      },
      username: {
        required,
        validUsername,
        minLength: minLength(4)
      },
      password: {
        required,
        minLength: minLength(8)
      },
      repeatPassword: {
        sameAsPassword: sameAs('password')
      },
      terms: {
        mustBeChecked
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoading', 'error'])
  },
  methods: {
    ...mapActions('auth', ['register']),

    getFieldState (name) {
      const field = this.$v.form[name]

      if (typeof field === 'undefined') {
        return null
      }

      if (field.$dirty && field.$error) {
        return false
      }

      return null
    },

    onSubmit (evt) {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.$refs.recaptcha.execute()
      }
    },
    onCaptchaVerified: function (recaptchaToken) {
      this.$refs.recaptcha.reset()
      this.register({
        email: this.form.email,
        username: this.form.username,
        password: this.form.password,
        next: this.$route.query.next,
        recaptchaToken
      })
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset()
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

.signup {
  margin: -48px -15px 0 -15px;
  padding-top: 48px;
  background-image: linear-gradient(to bottom, rgba(0,0,0,0) 57%, $body-bg),
                    url(/static/img/login-signup-bg.jpg);

  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  min-height: 90vh;

  .row {
    margin-top: 5em;
    margin-bottom: 5em;
  }

}

.form-decorated {
  margin: 3em;

  form {
    position: relative;
    z-index: 1;
  }

  .btn-decorated {
    position: absolute;
    left: calc(50% - 40px);
  }
}

.social-login {
  margin: 0 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/account/Signup.vue